import React, { useState } from 'react';
import './OnboardingPage.css';

const OnboardingPage = ({ onComplete, onSkip }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const onboardingSlides = [
    {
      id: 1,
      title: "Supporting Every Role",
      description: "Designed for doctors, assistants, and staff - simplifying calls, scheduling, and triage.",
      image: "/assets/images/onboarding_1.png",
      alt: "Healthcare professionals collaboration"
    },
    {
      id: 2,
      title: "Solving the Triple Whammy",
      description: "Automation and efficiency for an overburdened healthcare system.",
      image: "/assets/images/onboarding_2.png",
      alt: "Healthcare automation and efficiency"
    },
    {
      id: 3,
      title: "AI-Powered Workflows", 
      description: "From scheduling to billing - automation that's clear, reliable, and trustworthy.",
      image: "/assets/images/onboarding_3.png",
      alt: "AI-powered healthcare workflows"
    },
    {
      id: 4,
      title: "Built on Trust",
      description: "Transparency and clarity are at the heart of every workflow.",
      image: "/assets/images/onboarding_4.png",
      alt: "Trust and transparency in healthcare"
    },
    {
      id: 5,
      title: "Empowering Every Clinic",
      description: "Unlike big systems, Ankr delivers AI workflows tailored for mid-sized clinics.",
      image: "/assets/images/onboarding_5.png",
      alt: "Empowering clinics with AI"
    },
    {
      id: 6,
      title: "Ready to Get Started?",
      description: "Join thousands of healthcare providers already using Ankr to streamline their workflows and improve patient care.",
      image: "/assets/images/onboarding_6.png",
      alt: "Ready to get started with Ankr"
    }
  ];

  const nextSlide = () => {
    if (currentSlide < onboardingSlides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      onComplete();
    }
  };

  const prevSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const handleSkip = () => {
    onSkip();
  };

  const currentSlideData = onboardingSlides[currentSlide];
  const isLastSlide = currentSlide === onboardingSlides.length - 1;

  return (
    <div className="onboarding-overlay">
      <div className="onboarding-container">
        {/* Header */}
        <div className="onboarding-header">
        </div>

        {/* Main Content */}
        <div className="onboarding-content">
          {/* Image Container */}
          <div className="image-container">
            <img 
              src={currentSlideData.image}
              alt={currentSlideData.alt}
              className="onboarding-image"
              loading="eager"
            />
          </div>

          {/* Text Content */}
          <div className="text-content" style={{ minHeight: '125px' }}>
            <h1 className="onboarding-title">{currentSlideData.title}</h1>
            <p className="onboarding-description">{currentSlideData.description}</p>
          </div>

          {/* Progress Indicators */}
          <div className="progress-indicators">
            {onboardingSlides.map((_, index) => (
              <div
                key={index}
                className={`progress-dot ${currentSlide === index ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>

          {/* Navigation Buttons */}
          <div className="navigation-buttons">
            <button 
              className="nav-button next-button primary"
              onClick={nextSlide}
            >
              {isLastSlide ? 'Get Started' : 'Next'}
            </button>
            
            {currentSlide > 0 ? (
              <button 
                className="nav-button back-button"
                onClick={prevSlide}
              >
                Back
              </button>
            ) : (
              <button 
                className="nav-button back-button"
                onClick={handleSkip}
              >
                Skip
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingPage;